export class CreateClient {
    public countryId: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public password: string;

    constructor(
        countryId: string,
        email: string,
        firstName: string,
        lastName: string,
        password: string
    ) {
        this.countryId = countryId;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.password = password;
    }
}

export interface IIdentityClientUser {
    email: string,
    firstName: string,
    lastName: string,
    identityServerId: string,
    countryCode: string,
    countryId: string
}

export interface IClientPortalUser extends IIdentityClientUser {
    avatar?: string,
    birthdate?: Date,
    contactNumber?: string,
    tin?: string,
    clientPortalId?: number,
    entityGuid?: string,
    entityExists: boolean
}

export class ClientPortalUser implements IClientPortalUser  {
    email: string;
    firstName: string;
    lastName: string;
    identityServerId: string;
    clientPortalId?: number;
    countryCode: string;
    countryId: string;
    contactNumber?: string;
    tin?: string;
    birthdate?: Date;
    avatar?: string;
    entityGuid?: string;
    entityExists: boolean = false;
    
    constructor(client: IIdentityClientUser | IClientPortalUser) {
        this.email = client.email;
        this.firstName = client.firstName;
        this.lastName = client.lastName;
        this.countryCode = client.countryCode;
        this.countryId = client.countryId;
        this.identityServerId = client.identityServerId;

        if (this.isInstanceOfClientPortalUser(client)) {
            this.avatar = client.avatar;
            this.contactNumber = client.contactNumber;
            this.tin = client.tin;
            this.birthdate = client.birthdate;
            this.clientPortalId = client.clientPortalId;
            this.entityGuid = client.entityGuid;
            this.entityExists = client.entityExists;
        }
    }

    private isInstanceOfClientPortalUser(client: IIdentityClientUser | IClientPortalUser): client is IClientPortalUser {
        let clientPortalUserExclusiveProperties: string[] = ['cellphone', 'tin', 'birthdate', 'avatar'];
        return clientPortalUserExclusiveProperties.some((prop: string) => Object.hasOwn(client, prop));
    }
}